import createIcon from '../../createIcon';

/**
 * @component @name NoAdultContent
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMiAyWk00IDEyQzQgMTAuMTUgNC42MyA4LjQ2IDUuNjkgNy4xTDcuNTkgOUgxMC40Mkw3LjEgNS42OUM4LjQ2IDQuNjMgMTAuMTUgNCAxMiA0QzE2LjQxIDQgMjAgNy41OSAyMCAxMkMyMCAxMy44NSAxOS4zNyAxNS41NCAxOC4zMSAxNi45TDE2LjQxIDE1SDEzLjU4TDE2Ljg5IDE4LjMxQzE1LjU0IDE5LjM3IDEzLjg1IDIwIDEyIDIwQzcuNTkgMjAgNCAxNi40MSA0IDEyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE0LjI1IDE0TDEyLjc1IDEyTDE0LjI1IDEwSDEyLjc1TDEyIDExTDExLjI1IDEwSDkuNzVMMTEuMjUgMTJMOS43NSAxNEgxMS4yNUwxMiAxM0wxMi43NSAxNEgxNC4yNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik04IDEwTDcuMjUgMTFMNi41IDEwSDVMNi41IDEyTDUgMTRINi41TDcuMjUgMTNMOCAxNEg5LjVMOCAxMkw5LjUgMTBIOFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNiAxNEwxNi43NSAxM0wxNy41IDE0SDE5TDE3LjUgMTJMMTkgMTBIMTcuNUwxNi43NSAxMUwxNiAxMEgxNC41TDE2IDEyTDE0LjUgMTRIMTZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NoAdultContent = createIcon('NoAdultContent', [
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM4 12C4 10.15 4.63 8.46 5.69 7.1L7.59 9H10.42L7.1 5.69C8.46 4.63 10.15 4 12 4C16.41 4 20 7.59 20 12C20 13.85 19.37 15.54 18.31 16.9L16.41 15H13.58L16.89 18.31C15.54 19.37 13.85 20 12 20C7.59 20 4 16.41 4 12Z',
      key: 'cjna2e',
    },
  ],
  [
    'path',
    {
      d: 'M14.25 14L12.75 12L14.25 10H12.75L12 11L11.25 10H9.75L11.25 12L9.75 14H11.25L12 13L12.75 14H14.25Z',
      key: 'dqcc72',
    },
  ],
  [
    'path',
    { d: 'M8 10L7.25 11L6.5 10H5L6.5 12L5 14H6.5L7.25 13L8 14H9.5L8 12L9.5 10H8Z', key: '1uo7nj' },
  ],
  [
    'path',
    {
      d: 'M16 14L16.75 13L17.5 14H19L17.5 12L19 10H17.5L16.75 11L16 10H14.5L16 12L14.5 14H16Z',
      key: 'p664o9',
    },
  ],
]);

export default NoAdultContent;
